import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const  ViewDetailsBtn = (props) => {
    const t = useTranslate();
    const history = useHistory();

    const handleEdit = (path) => {
        if(props.path){
            history.push(path);
            props.setShow(false);
        }else if(props.paramShow){
            props.setShow(props.paramShow);
            props.setDataToShow(props.dataToShow)
        }
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('btnShowDetails')}
                </Tooltip>
            }
        >
            <span onClick={() => handleEdit(props.path)} style={{cursor:'Pointer', color:'#FF8919'}}><FontAwesomeIcon icon={faEye} /></span>
        </OverlayTrigger>  
    )
}

export default ViewDetailsBtn;